import React, { FC, ReactNode } from 'react'
import classNames from 'classnames'
import { Spinner } from '../Spinner'

export interface IFacetProps {
  id: string
  dataTest: string
  icon?: JSX.Element
  label: string
  /**
   * Pass in an optional badge that appears after label
   */
  badge?: ReactNode
  isLoading?: boolean
  className?: string
  buttonClassName?: string
  selected: boolean
  onClick: (selected: boolean, id?: string) => void
}

export const Facet: FC<IFacetProps> = ({
  badge,
  buttonClassName,
  className,
  dataTest,
  icon,
  id,
  isLoading,
  label,
  onClick,
  selected,
}) => {
  const buttonClasses = classNames('filter-pill tl facet', buttonClassName, {
    'applied bg-tertiary': selected && !isLoading,
  })

  const labelClasses = classNames('nowrap', {
    'text-default': !(selected && !isLoading),
    'ml4 pl2 pr2': icon,
  })
  const buttonClickHandler = () => {
    onClick(!selected, id)
  }
  return (
    <div className={className} data-test={dataTest}>
      <button id={id} className={buttonClasses} type='button' onClick={buttonClickHandler}>
        <div className='flex flex-row items-center relative'>
          {icon && <div className='pr2 prefix-icon'>{icon}</div>}
          <b className={labelClasses}>{label}</b>
          {isLoading ? <Spinner position='relative' /> : badge}
        </div>
      </button>
    </div>
  )
}

export default Facet
